import { render, staticRenderFns } from "./KpiComposedChart.vue?vue&type=template&id=1a057ae5&scoped=true"
import script from "./KpiComposedChart.vue?vue&type=script&lang=js"
export * from "./KpiComposedChart.vue?vue&type=script&lang=js"
import style0 from "./KpiComposedChart.vue?vue&type=style&index=0&id=1a057ae5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a057ae5",
  null
  
)

export default component.exports